import dayjs from 'dayjs';
import emailRegexSafe from 'email-regex-safe';
import {Condition} from './types';

export const THRESHOLD = 500;
/**
 * Need to change once finalized the link URL
 */
export const EXPLORE_LINK_URL = '/https://aurora-review.consilio.com/';

export const ASSIGNMENT_TYPES = {
  GROUP: 'assignmentgroup',
  DEFAULT: 'default',
} as const;

export const conditions = [
  'Not set',
  'Is',
  'Is before',
  'Is before or on',
  'Is after',
  'Is after or on',
  'Between',
] as const;
export const conditionToTextKey: Record<Condition, string> = {
  'Not set': 'common.arrDatePicker.conditions.notSet',
  Is: 'common.arrDatePicker.conditions.is',
  'Is before': 'common.arrDatePicker.conditions.isBefore',
  'Is before or on': 'common.arrDatePicker.conditions.isBeforeOrOn',
  'Is after': 'common.arrDatePicker.conditions.isAfter',
  'Is after or on': 'common.arrDatePicker.conditions.isAfterOrOn',
  Between: 'common.arrDatePicker.conditions.between',
};

export const gridDateOperatorObj: Record<Condition, string[]> = {
  'Not set': [],
  Is: ['is'],
  'Is before': ['before'],
  'Is before or on': ['onOrBefore'],
  'Is after': ['after'],
  'Is after or on': ['onOrAfter'],
  Between: ['onOrAfter', 'onOrBefore'],
};

export const todayYear = dayjs().year();

export const panelWidths = {
  small: 42.5,
  large: 59,
};
export const PAGE_SIZE = 10;

export const EMAIL_ADDRESS_REGEX = emailRegexSafe({exact: true, strict: true});

/**
 * Regex which validating alpha numeric + space char
 */
export const FIRST_LAST_NAME_REGEX = /^[a-zA-Z0-9 ]+$/;

export const COMMENT_REGEX = /^[A-Za-z]\w*$/;

export const TAG_NAME_REGEX = /^[A-Za-z0-9_ ]+$/;

export const COMMENT_CHAR_LIMIT = 128;

export const pagination_page_limit = 10;

export const transition_time_default = 300;

export const rolesList = [
  'systemAdmin',
  'domainAdmin',
  'projectAdmin',
  'reviewManager',
  'reviewers',
];
export const FOOTER_LINKS = {
  privacyPolicy: 'https://www.consilio.com/privacy-policy',
  eula: 'https://launchpoint.consilio.com/assets/docs/aurora-eula-2025.pdf',
  cookiePolicy: 'https://www.consilio.com/privacy/cookie-policy',
  modernAntiSlaveryPolicy:
    'https://www.consilio.com/modern-anti-slavery-policy',
  termsOfService: '#',
};

export const TOAST_DURATION = 5000;

export enum PermissionSection {
  Rights = 'Rights',
  Reports = 'Reports',
  DocViewControls = 'Doc View Controls',
}

export enum RoleId {
  DomainAdministrator = '-2',
  ProjectAdministrator = '1',
  ReviewManager = '2',
  Reviewer = '3',
  SystemAdministrator = '-1',
}

export enum ToastType {
  Success = 'success',
  Error = 'error',
  Warning = 'warning',
}

export const MAX_STATUS_ICONS = 48;

export const ANNOTATION_TAB_INDEX = 4;

export const TABLE_KEYS = {
  name: 'name',
  distributed: 'distributed',
  completed: 'completed',
  todo: 'todo',
} as const;

export const NO_DATA_PLACEHOLDER = '--';
export const PERCENTAGE = '%';

export enum RoleNames {
  SystemAdministrator = 'System Administrator',
  DomainAdministrator = 'Domain Administrator',
  ProjectAdministrator = 'Project Administrator',
  ReviewManager = 'Review Manager',
  Reviewer = 'Reviewer',
}

export enum ReportTypes {
  DOMAINDASHBOARDXPORT = 'DOMAINDASHBOARDXPORT',
}

export enum ActionType {
  SaveReport = 'SAVEREPORT',
  ExportReport = 'EXPORTREPORT',
}

export enum ReportTypeCode {
  EXPORT_REPORT = 'CDR011',
  REVIEWER_PRODUCTIVITY_REPORT = 'RPD007',
}
export const GRID_SORT_ORDER: ('asc' | 'desc')[] = ['asc', 'desc'];

export const MAX_FOLDER_NAME_LENGTH = 250;

/**
 * ARR Select Drop Down
 */
export const DEBOUNCE_SEARCH_TIME_OUT = 400;
export const POSITION_HEIGHT = {
  AVAILABLE_SPACE: 300,
  RESERVED_HEIGHT_SEARCH_ROW: 50,
  AVAILABLE_HEIGHT_FACTOR: 0.8,
  MAX_HEIGHT_MENU: 600,
  DEFAULT_MAX_HEIGHT: 100,
};
export const SCROLL_THRESHOLD = 60;
export enum SourceTypeCode {
  DOCEXPLORER = 'DOCEXPLORER',
  DOCVIEW = 'DOCVIEW',
  DOCUMENT = 'DOCUMENT',
  PRODUCTION = 'PRODUCTION',
  PRODUCTIONTOTAL = 'PRODUCTIONTOTAL',
  PRODUCTIONFAMILY = 'PRODUCTIONFAMILY',
  SEARCHNAME = 'SEARCHNAME',
  ADVBATMGMTRPT = 'ADVBATMGMTRPT',
  DOCLIST = 'DOCLIST',
  ASSIGNMENT = 'ASSIGNMENT',
  REVIEWERDASHBOARD = 'REVIEWERDASHBOARD',
  CONCEPTEXPLORER = 'CONCEPTEXPLORER',
  SESSIONSEARCH = 'SESSIONSEARCH',
  TIMELINE = 'TimeLine',
  TALLY = 'TALLY',
  SUBTALLY = 'SUBTALLY',
  EXPORTDATA = 'EXPORTDATA',
  COMMUNICATIONMAP = 'COMMUNICATIONMAP',
  SEARCHTERM = 'SEARCHTERM',
  INGESTION = 'INGESTION',
  SAVEDSEARCH = 'SAVEDSEARCH',
  FOLDER = 'FOLDER',
  ASSIGNMENTREVIEWER = 'ASSIGNMENTREVIEWER',
  TAG = 'TAG',
  SEARCH = 'SEARCH',
  BULKTAG = 'BULKTAG',
}

export const DocMaxLimitDestinationCode = {
  DATASETDOCVIEW: 'DATASETDOCVIEW',
  DATASETDOCLIST: 'DATASETDOCLIST',
} as const;

export type DocMaxLimitDestination =
  | SourceTypeCode.DOCVIEW
  | SourceTypeCode.DOCLIST
  | (typeof DocMaxLimitDestinationCode)[keyof typeof DocMaxLimitDestinationCode];

export enum SourceTypeContextCode {
  ADVBATCHMGTNOC = 'ADVBATCHMGTNOC',
  TIMELINENOC = 'TIMELINENOC',
  DOCLISTNOC = 'DOCLISTNOC',
  TALLY = 'TALLYNOC',
  SUBTALLY = 'SUBTALLYNOC',
  SEARCHTERMNOC = 'SEARCHTERMNOC',
  SAVEDSEARCHWC = 'SAVEDSEARCHWC',
  SAVEDSEARCH = 'SAVEDSEARCH',
  MANAGETAGNOC = 'MANAGETAGNOC',
  MANAGEFOLDERNOC = 'MANAGEFOLDERNOC',
}

export enum BgNavigationTypes {
  NAV_PAYLOAD_COMPLETE = 'BGNavigationsPayloadCompleted',
  NAV_PAYLOAD_ERROR = 'BGNavigationsPayloadError',
}

export enum DOC_TYPE {
  PDF = 'pdf',
  TEXT = 'txt',
  TIFF = 'tiff',
  AUDIO_MP3 = 'media',
  NATIVE = 'native',
}

export enum PROPOGATION_TYPE {
  FAMILY = 'Family',
  DUPLICATES = 'Duplicates',
  EMAILTHREADS = 'EmailThreads',
  EMAILDUPLICATES = 'EmailDuplicates',
}

export const NOTIFICATIONS_HUB_URL =
  'https://arr-dev-notification.us2kd2w30.k8d.consiliotest.com/hub/notifications';

export const REGX = {
  VALID_FIELD_NAME_CHARS: /^[A-Za-z0-9 _]+$/, // allows letters, digits, space, underscore
  VALID_FIELD_NAME_FIRST_CHAR: /^[A-Za-z0-9 ]/, // cannot start with _, cannot start with special char
};

export const COLOR_MAP: Record<string, string> = {
  Aqua: '#29D8E1',
  Blue: '#A5C1FF',
  Brown: '#D67603',
  Cyan: '#00AFB8',
  Chocolate: '#D2691E',
  Fuchsia: '#FF00FF',
  Gold: '#E6C104',
  Gray: '#A5B4CB',
  Green: '#04A269',
  Lime: '#D0DB57',
  Maroon: '#800000',
  Navy: '#000080',
  Orange: '#FF9E2C',
  Pink: '#FFA3A3',
  Purple: '#9F75DF',
  Red: '#F55259',
  Silver: '#CCD5E3',
  SkyBlue: '#6E87FF',
  Violet: '#C4AAEB',
  Yellow: '#FFEC5B',
  YellowGreen: '#A7B22E',
  LightBlue: '#D3E4FF',
  Mango: '#FFC37D',
  Mint: '#A5E9D0',
  Pear: '#E2E997',
};

export const TIMELINE_COLOR_MAP: Record<string, string> = {
  HighlightGrey: '#687E9F',
  DefaultSeries: '#687E9F',
  TextBodyStrong: '#CCD5E3',
  Yearly: '#6E87FF',
  Monthly: '#00D0DB',
  Daily: '#9F75DF',
  Grid: '#3c4f6b',
};
export const TIMELINE_BAR: Record<string, string> = {
  BarHeight: '320px',
};
export const redactionStatus: Record<string, string> = {
  complete: 'COMPLETE',
  failed: 'FAILED',
  preprocessing: 'PROCESSING',
  rollback: 'ROLLEDBACK',
};

export enum ReportActionMenuOptionTypes {
  View = 'View',
  ViewInDocView = 'ViewInDocView',
  ViewInDocViewNewTab = 'ViewInDocViewNewTab',
  ViewInDocList = 'ViewInDocList',
  BulkTag = 'BulkTag',
  BulkFolder = 'BulkFolder',
  BulkAssign = 'BulkAssign',
  BulkRelease = 'BulkRelease',
  QuickBatch = 'QuickBatch',
  ExportData = 'ExportData',
  Unassign = 'Unassign',
  Redistribute = 'Redistribute',
  GenerateGap = 'GenerateGap',
  Yearly = 'Yearly',
  Monthly = 'Monthly',
  Daily = 'Daily',
  Tally = 'Tally',
  SubTally = 'SubTally',
  TimelineAndGaps = 'TimelineAndGaps',
}

export const TimelineTypes = {
  DAILY: 'DAILY',
  MONTHLY: 'MONTHLY',
  YEARLY: 'YEARLY',
};

export const redactionActions: Record<string, string> = {
  Rollback: 'ROLLBACK',
  Report: 'REPORT',
  ActionCode: 'BRRPT',
  ExportContextType: 'BATCHREDACTION',
};

export const existingObjErrCode = '80001000001';

export const REDACTION_SIGNALR_TYPE = 'DocumentArtNotification';

export enum ActionTypes {
  TAGNonBG = 'TAGNonBG',
  TAG = 'TAG',
}

export const AI_EXPORT_KEYVALUE = {
  id: 'ai-summary',
  label: 'AI Generated Summary',
};

export const MANAGE_INDEX_DATA_UPDATED_NOTIFICATION =
  'ManageIndexDataUpdatedNotification';
